(function(){
  function init(){
    document.querySelectorAll('.gtfo-filter-panel-body').forEach(function(panel){
      if(panel.dataset.gtfoReady) return;
      panel.dataset.gtfoReady='true';
      panel.querySelectorAll('.pt-display-search').forEach(function(group){
        var input=group.querySelector('.fm-search-box');
        if(!input)return;
        input.style.display='block';
        input.setAttribute('aria-label','Search '+(group.querySelector('h4')||{}).textContent);
        input.addEventListener('input',function(){
          var term=input.value.toLowerCase().trim();
          group.querySelectorAll('li.collection-container').forEach(function(item){
            item.hidden=!!term&&item.textContent.toLowerCase().indexOf(term)===-1;
          });
        });
      });
      panel.querySelectorAll('.filter-group ul').forEach(function(list){
        var items=Array.from(list.children).filter(function(item){return item.matches('li.collection-container');});
        if(items.length<=11||list.classList.contains('has_selected'))return;
        var rest=items.slice(10).filter(function(item){return !item.classList.contains('selected');});
        if(!rest.length)return;
        rest.forEach(function(item){item.hidden=true;});
        var row=document.createElement('li'),button=document.createElement('button');
        button.type='button';button.className='gtfo-filter-more';button.textContent='Show more';button.setAttribute('aria-expanded','false');
        row.appendChild(button);list.appendChild(row);
        button.addEventListener('click',function(){
          rest.forEach(function(item){item.hidden=false;});
          button.setAttribute('aria-expanded','true');row.remove();
        });
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('collection:reloaded',init);
  var pending=false;
  var observer=new MutationObserver(function(){if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;init();});});
  var main=document.getElementById('MainContent');if(main)observer.observe(main,{childList:true,subtree:true});
})();